"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _validate = _interopRequireDefault(require("validate.js"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

/**
 * Collection of constrains for all fields.
 * TODO: if the file is getting too big, we need to find a better way to split the codes.
 */
var Constraint = /*#__PURE__*/function () {
  function Constraint() {
    _classCallCheck(this, Constraint);
  }

  _createClass(Constraint, null, [{
    key: "required",
    get: function get() {
      return {
        presence: {
          allowEmpty: false,
          message: '^required'
        },
        length: {
          minimum: 1
        }
      };
    }
  }, {
    key: "phoneNumber",
    get: function get() {
      return {
        presence: {
          allowEmpty: false,
          message: '^phone_number_required'
        },
        format: {
          pattern: '^0[1-9]\\d{0,3}-\\d{1,4}-\\d{3,4}$',
          message: '^phone_number_telCheck'
        },
        length: {
          minimum: 12,
          maximum: 13,
          message: '^phone_number_rangelength'
        }
      };
    }
  }, {
    key: "phoneNumberWorld",
    get: function get() {
      return {
        format: {
          pattern: '[0-9\\-−‐ー+＋]+$',
          message: '^phone_number_worldTelCheck'
        }
      };
    }
  }, {
    key: "firstName",
    get: function get() {
      return {
        presence: {
          allowEmpty: false,
          message: '^first_name_required'
        },
        length: {
          maximum: 40,
          message: '^first_name_maxlength'
        }
      };
    }
  }, {
    key: "lastName",
    get: function get() {
      return {
        presence: {
          allowEmpty: false,
          message: '^last_name_required'
        },
        length: {
          maximum: 40,
          message: '^last_name_maxlength'
        }
      };
    }
  }, {
    key: "companyName",
    get: function get() {
      return {
        presence: {
          allowEmpty: false,
          message: '^company_name_required'
        },
        length: {
          maximum: 70,
          message: '^company_name_maxlength'
        }
      };
    }
  }, {
    key: "officeName",
    get: function get() {
      return {
        length: {
          maximum: 100,
          message: '^office_name_maxlength'
        }
      };
    }
  }, {
    key: "departmentName",
    get: function get() {
      return {
        presence: {
          allowEmpty: false,
          message: '^department_required'
        },
        length: {
          maximum: 255,
          message: '^department_maxlength'
        }
      };
    }
  }, {
    key: "businessType",
    get: function get() {
      return {
        presence: {
          allowEmpty: false,
          message: '^business_types_required'
        }
      };
    }
  }, {
    key: "jobCategoryType",
    get: function get() {
      return {
        presence: {
          allowEmpty: false,
          message: '^job_category_types_required'
        }
      };
    }
  }, {
    key: "subdivisionCode",
    get: function get() {
      return {
        presence: {
          allowEmpty: false,
          message: '^subdivision_code_required'
        }
      };
    }
  }, {
    key: "email",
    get: function get() {
      return {
        email: {
          message: '^clip.email.invalid'
        },
        presence: {
          allowEmpty: false,
          message: '^clip.email.required'
        }
      };
    }
  }]);

  return Constraint;
}();

exports.default = Constraint;